// import React from 'react';
import ISOLogo from '@/images/layout/ISO-27001.png';
import SOC2Logo from '@/images/layout/SOC-2.svg';
import CCPALogo from '@/images/layout/CCPA.svg';
import GDPRLogo from '@/images/layout/GDPR.svg';
import SSLLogo from '@/images/layout/SSL.svg';
import APPIJPLogo from '@/images/layout/APPI-JP.svg';

export const TOOL_ENTRIES_EN = [
  {
    label: 'Audio to Text Converter',
    url: '/en/tools/audio-to-text-converter',
  },
  {
    label: 'Online Video Converter',
    url: '/en/tools/online-video-converter',
  },
  {
    label: 'Online Audio Converter',
    url: '/en/tools/online-audio-converter',
  },
  {
    label: 'Online Vocal Remover',
    url: '/en/tools/online-vocal-remover',
  },
];

export const TOOL_ENTRIES_JA = [
  {
    label: 'オンライン音声文字起こしコンバーター',
    url: '/tools/audio-to-text-converter',
  },
  {
    label: 'フリーオンライン動画変換',
    url: '/tools/online-video-converter',
  },
  {
    label: 'オンライン音声変換',
    url: '/tools/online-audio-converter',
  },
  {
    label: 'ボーカルリムーバー',
    url: '/tools/online-vocal-remover',
  },
];

export const USE_CASES_ENTRIES_JA = [
  {
    label: '聴覚障がい者',
    url: '/use-cases/hearing-impaired',
  },
  {
    label: '営業担当',
    url: '/use-cases/business',
  },
  {
    label: 'ライター',
    url: '/use-cases/writer',
  },
  {
    label: '学生',
    url: '/use-cases/student',
  },
];

export const SECURITY_LOGOS = [
  {
    src: ISOLogo,
    alt: 'ISO',
  },
  {
    src: SOC2Logo,
    alt: 'SOC 2',
  },
  {
    src: CCPALogo,
    alt: 'CCPA',
  },
  {
    src: GDPRLogo,
    alt: 'GDPR',
  },
  {
    src: SSLLogo,
    alt: 'SSL',
  },
  {
    src: APPIJPLogo,
    alt: 'APPI',
  },
];
